import {useEffect, useRef, useState} from "react";
import {
  alpha, Backdrop,
  Box, Button,
  CircularProgress, Divider, IconButton, InputAdornment, InputBase,
  ListItem, Menu, MenuItem,
  Snackbar, styled,
} from "@mui/material";
import {ProgressDiv} from "../styles";
import {useHistory} from "react-router-dom";
import {getComparableText, getPurchaseNameSummary, getWarehouseNameFromState} from "../stringutils";
import axios from "axios";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY, Search, SearchIconWrapper, StyledInputBase} from "../constant";
import {getBuyCond, isPurchased, textColorByPurchaseState, textDecorationByPurchaseState} from "../osp_utils";
import {
  ArrowDropDownOutlined,
  ClearRounded,
  InfoSharp,
  LockSharp
} from "@mui/icons-material";
import {useWarehouseState} from "../WarehouseContext";
import SearchIcon from '@mui/icons-material/Search';
import {FixedSizeList} from "react-window";
import useWindowDimensions from "../Dimension";


const LIST_HEIGHT = 180
const MAX_WIDTH = 480
const SAVE_SCROLL_KEY = 'buy_list_scrollY'


const BUY_STATE = {
  ALL : 0,
  AVAILABLE : 1,
  COMPLETE : 2
}
Object.freeze(BUY_STATE)

export function ListToBuy(props) {

  const history = useHistory()
  const warehouseState = useWarehouseState()
  const listRef = useRef(null)

  const [searchText, setSearchText] = useState('')
  const [message, setMessage] = useState({
    text : '',
    error : false,
  })
  const { windowHeight, windowWidth } = useWindowDimensions();

  const [requesting, setRequesting] = useState(false)
  const [results, setResults] = useState([])
  const [list, setList] = useState([])

  const [snackbar, setSnackbar] = useState({
    open : false,
    message : '',
  })

  const [buyStateFilterMenuAnchorEl, setBuyStateFilterMenuAnchorEl] = useState(null)
  const buyStateFilterMenuOpen = Boolean(buyStateFilterMenuAnchorEl)
  const [warehouseMenuAnchorEl, setWarehouseMenuAnchorEl] = useState(null)
  const warehouseMenuOpen = Boolean(warehouseMenuAnchorEl)

  const getWarehouseFilterName = (val) =>{
    if(val === '-1'){
      return '모든창고 '
    }
    return getWarehouseNameFromState(parseInt(val), warehouseState) + '창고'
  }
  const selectWarehouse = (event, val) => {
    val = val.toString()
    console.log(val, results)
    closeWarehouseMenu()
    setWarehouseFilter(val.toString());
    setWarehouseFilterName(getWarehouseFilterName(val))

    filterList(val, buyStateFilter, results)
  };

  const selectBuyStateFilter = (event, val) => {
    console.log('selectBuyStateFilter ' + val)
    closeBuyStateFilterMenu()
    setBuyStateFilter(val)

    filterList(warehouseFilter, val, results)
  };



  // const [buyStateFilter, setBuyStateFilter] = useState(BUY_STATE.ALL)
  const [buyStateFilter, setBuyStateFilter] = useState(()=>{
    let state = localStorage.getItem('lastBuyStateFilter')
    console.log('lastBuyStateFilter ' + state)
    if(Boolean(state)){
      return parseInt(state)
    }
    return BUY_STATE.ALL
  })

  const [warehouseFilter, setWarehouseFilter] = useState(()=>{
    let state = localStorage.getItem('lastWarehouseFilter')
    console.log('lastWarehouseFilter ' + state)
    if(Boolean(state)){
      return state
    }
    return '-1'
  })

  const [warehouseFilterName, setWarehouseFilterName] = useState(()=>{
    let state = localStorage.getItem('lastWarehouseFilter')

    if(Boolean(state)){
      return getWarehouseFilterName(state)
    }
    return '모든창고'
  })

  const filterList = (warehouse, buyState, list) => {
    console.log(`filter list ${warehouse}, ${buyState}`)
    if(warehouse !== '-1' || buyState > BUY_STATE.ALL){
      setList(list.filter((value) => {
        // if(warehouse !== '-1'){
        //   return value.dest === warehouse
        // }
        let buyStateCond = true
        switch (buyState) {
          case BUY_STATE.AVAILABLE:
            buyStateCond = (!isPurchaseNotAvailable(value) && !isPurchased(value))
            break
          case BUY_STATE.COMPLETE:
            buyStateCond = (isPurchaseNotAvailable(value) || isPurchased(value))
            break
        }

        return (warehouse === '-1' || value.dest === warehouse) && buyStateCond
      }))
    }else{
      setList(list)
    }
  }


  const closeWarehouseMenu = () =>{
    setWarehouseMenuAnchorEl(null)
  }

  const closeBuyStateFilterMenu = () => {
    setBuyStateFilterMenuAnchorEl(null)
  }

  const restoreScroll = () => {
    let lastScrollY = localStorage.getItem(SAVE_SCROLL_KEY);
    console.log('restore lastScrollY', lastScrollY)
    if (listRef && listRef.current && lastScrollY) {
      listRef.current.scrollTo(lastScrollY);
      window.scrollTop = 0
      // window.innerHeight = windowHeight
      // window.scrollBy(0, 0);
      window.scrollTo(0, 0);
      localStorage.removeItem(SAVE_SCROLL_KEY);
    }
  }

  useEffect(()=>{


    localStorage.removeItem(`lastWarehouseFilter`)
    localStorage.removeItem('lastBuyStateFilter')
    return (()=>{
      console.log('save filter ' + warehouseFilter + ' '+ buyStateFilter)
      localStorage.setItem(`lastWarehouseFilter`, warehouseFilter)
      localStorage.setItem(`lastBuyStateFilter`, buyStateFilter)
    })
  }, [warehouseFilter, buyStateFilter])

  useEffect(()=>{

    setMessage({text: '', error: false})

    // console.log('window.history.scrollRestoration ' + window.history.scrollRestoration)
    console.log('request list to buy ' + history.action)
    setRequesting(true)

    axios.get(`${process.env.REACT_APP_API_HOST}/osrequest`, {
      params : {
        token : cookie.load(RECEIVER_COOKIE_KEY),
        // range : 'today',
        range : 'yesterday',
      }
    }).then((resp)=>{
      // console.log(resp)
      setRequesting(false)
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {
        if (resp.data['results'].length > 0) {

          props.onList(resp.data['results'])
          console.log(resp.data['results'])

          setResults(resp.data['results'])
          filterList(warehouseFilter, buyStateFilter, resp.data['results'])
          // setList(resp.data['results'])
          restoreScroll()
          return;
        } else {
          props.onList(null)
          setMessage({
            text: "구매할 목록이 없습니다.",
            error: false
          })

        }
      }else if(resp.status === 200 && resp.data != null && resp.data['code'] === 0){
        history.replace('/signin')
      }else{
        console.error(resp)
        props.onList(null)
        setMessage({
          text : "에러가 발생했습니다. 잠시후 다시 이용해보세요",
          error: true
        })
      }

      localStorage.removeItem(SAVE_SCROLL_KEY);

    }).catch((e)=>{
      console.error(e)
      props.onList(null)
      setMessage({
        text : "에러가 발생했습니다. 잠시후 다시 이용해보세요",
        error: true
      })
      localStorage.removeItem(SAVE_SCROLL_KEY);
    })

    return (()=> {
      console.log('save lastScrollY ', window.scrollPosition)

      localStorage.setItem(SAVE_SCROLL_KEY, window.scrollPosition);
      window.scrollPosition = 0
    })

  },[])

  if(Boolean(message.text))
    return(
      <Box sx={{
        pt : 12,
        // backgroundColor: (theme) => theme.palette.grey[100],
        flexGrow : 1,
        flexDirection : 'column',
        display : 'flex', width : '100%', justifyContent : 'center', alignItems : 'center'}}>
        {message.error ? <InfoSharp color={'error'}/> : <div/>}
        <Box
          sx={{mt : 2}}
        >
          {message.text}
        </Box>
        {/*{message.error ?*/}
        {/*  <Button*/}
        {/*    sx={{mt : 6}}*/}
        {/*    variant={"outlined"}*/}
        {/*    color={"secondary"}>*/}
        {/*    다시시도*/}
        {/*  </Button>*/}
        {/*  : <div/>}*/}
      </Box>
    )


  const isPurchaseLimitExceed = (buy) => {
    if(buy.purchase_limit > 0 && buy.purchased_count >= buy.purchase_limit){
      return true;
    }
    return false;
  }

  const isPurchaseMinInvenExceed = (buy) => {
    for(const p of buy.purchase){
      let minInven = p.min_inven
      let totInven = p.total_inven
      if (isNaN(parseInt(minInven))) minInven = "0";
      if (isNaN(parseInt(totInven))) totInven = "0";
      let _totInven = parseInt(totInven);
      let _minInven = parseInt(minInven);

      if (!(_minInven === 0 || _totInven === 0 || _totInven < _minInven)){
        return true
      }
    }


    return false

  }

  const isPurchaseNotAvailable = (buy) => {
    return isPurchaseMinInvenExceed(buy) || isPurchaseLimitExceed(buy)
  }

  const isShowScrollbar = () => {

    let height = list.length * LIST_HEIGHT

    if(height > (windowHeight - 194)){
      return true
    }

    return false
  }

  const listRow = ({index , style}) => {
    const item = list[index]
    return <div key={index} style={{...style, display : 'flex', flexDirection : 'column', alignItems : 'center', marginRight :12,}}>
      {/*<Box sx={{height : LIST_HEIGHT, maxWidth : MAX_WIDTH, pl : 2, pr : 2}}>*/}
       <ListItem
          sx={{
            height : '100%',
            // height : LIST_HEIGHT,
            maxWidth : MAX_WIDTH,
            backgroundColor : isPurchaseNotAvailable(item) ? '#e0e0e0' : 'white'
          }}
          component={"div"}
          onClick={()=> {

            if(!isPurchased(item) && isPurchaseNotAvailable(item)){
              console.log('limit exceed purchase')
              return;
            }
            history.push('/detail', {buy : item,})
          }}
        >
          <Box sx={{
            width: '100%',
          }}>
            {/*<Box sx={{*/}
            {/*  textDecorationLine: textDecorationByPurchaseState(item),*/}
            {/*  color: textColorByPurchaseState(item),*/}
            {/*  fontWeight: 'medium',*/}
            {/*  mt : 1*/}
            {/*}}>*/}
            {/*  {moment(new Date(item.create_date)).format('YYYY/MM/DD HH:mm')}*/}
            {/*</Box>*/}
            <Box
              sx={{
              textDecorationLine: textDecorationByPurchaseState(item),
              color: textColorByPurchaseState(item),
              fontWeight: 'medium',
              mt : 1
              }}
            >
              {getBuyCond(item) + ' / ' + getWarehouseNameFromState(parseInt(item.dest), warehouseState) + '창고'}
            </Box>
            <Box sx={{
              textDecorationLine: textDecorationByPurchaseState(item),
              color: textColorByPurchaseState(item),
              fontWeight: 'medium',
              mt : 1
            }}>
              {'링크 - ' + item.shop_name}
            </Box>
            <Box sx={{
              textDecorationLine: textDecorationByPurchaseState(item),
              color: textColorByPurchaseState(item),
              fontWeight: 'medium',
              mt : 1
            }}>
              {getPurchaseNameSummary(item.purchase)}
            </Box>
            <Box
                sx={{
                  marginTop : 1,
                  display : 'flex',
                  flexDirection : 'row',
                  alignItems : 'center'
                }}
              >
              {
                isPurchaseNotAvailable(item)?
                  <Box
                    sx={{
                      display : 'flex',
                      flexDirection : 'row',
                      alignItems : 'center',
                      justifyContent : 'center',
                      fontWeight : 'medium',
                      fontSize : 16,
                      color : 'red'
                    }}
                  >
                    <LockSharp fontSize={"small"} color={'error'}/>
                    구매마감
                    {/*{*/}
                    {/*  isPurchaseMinInvenExceed(item)*/}
                    {/*  ? "구매마감(재고초과)" : "구매마감"*/}
                    {/*}*/}

                  </Box>
                  :
                  <div/>
              }

              <Box
                sx={{
                  textDecorationLine: textDecorationByPurchaseState(item),
                  color: textColorByPurchaseState(item),
                  marginTop : 1,
                  paddingBottom : 1,
                  display: 'flex',
                  flexGrow: 1,
                  fontWeight: 'medium',
                  justifyContent: 'flex-end',
                  fontSize : 24,
                }}
              >
                {item.total_price.toLocaleString() + '원'}
              </Box>
            </Box>

          </Box>
        </ListItem>
        <Divider/>
      {/*</Box>*/}

    </div>
  }

  const getBuyStateFilterName = (state) => {
    switch (state){
      case BUY_STATE.AVAILABLE:
        return "구매가능"
      case BUY_STATE.COMPLETE:
        return "구매완료"
      default:
      case BUY_STATE.ALL:
        return "모두보기"
    }
  }

  return (
    <Box sx={{
      backgroundColor: (theme) => theme.palette.grey[100],
      flexGrow : 1,
      height : '100%',
      display : 'flex', width : '100%', justifyContent : 'center'}}>
      {
        requesting ?
          <ProgressDiv>
            <CircularProgress size={34} thickness={4}/>
          </ProgressDiv>
          :

          <Box sx={{ display : 'flex', width : '100%', flexDirection : 'column', alignItems : 'center', }}>
            <Box sx={{
              //position : 'fixed', top : 72,
              display : 'flex', width: '100%', maxWidth: MAX_WIDTH, paddingBottom : 1, }}>
              <Search sx={{height : 48, maxWidth : MAX_WIDTH, width : '100%'}}>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  value={searchText}
                  onKeyUp={(e) => {
                    if(e.key === "Enter"){
                      e.target.blur()
                    }
                  }}
                  onChange={(e)=>{

                    console.log("onChange " + e.target.value )
                    let value = e.target.value
                    setSearchText(value)
                    if(value && value.length > 0){
                      const compareValue = getComparableText(value);
                      setList(results.filter((item) => {
                        if(item && item.purchase){
                          for(let p of item.purchase){
                            if(p.buy_cond && getComparableText(p.buy_cond).includes(compareValue)){
                              return true;
                            }
                          }
                        }
                        if(item.shop_name && getComparableText(item.shop_name).includes(compareValue)){
                          return true;
                        }
                        for(let purchase of item.purchase){
                           if(purchase.name && getComparableText(purchase.name).includes(compareValue)){
                             return true;
                           }
                        }

                        return false;
                      }))
                    }else{
                      setList(results)
                    }

                  }}
                  placeholder="상품명/링크/결제조건으로 검색..."
                  endAdornment={
                    <InputAdornment position="end">
                      {
                        searchText && searchText.length > 0 ?
                          <IconButton
                            sx={{mr : 1}}
                            onClick={()=>{
                              setSearchText("")
                              setList(results)
                              listRef?.current?.scrollTo(0)
                            }}
                            edge="end"
                          >
                            <ClearRounded/>
                          </IconButton>
                          :
                          <div/>
                      }
                    </InputAdornment>
                  }
                />

              </Search>
            </Box>
            <Box sx={{display : 'flex', width : '100%', maxWidth: MAX_WIDTH, justifyContent : 'start'}}>
              <Button
                  aria-multiline={false}
                  onClick={(event)=>{
                    setBuyStateFilterMenuAnchorEl(event.target)
                  }}
                  variant={"text"}
                  endIcon={<ArrowDropDownOutlined/>}
                >
                {getBuyStateFilterName(buyStateFilter)}
              </Button>
              <Menu
                id="state-menu"
                anchorEl={buyStateFilterMenuAnchorEl}
                open={buyStateFilterMenuOpen}
                onClose={closeBuyStateFilterMenu}
              >
                <MenuItem key={BUY_STATE.ALL} onClick={(ev)=>selectBuyStateFilter(ev, BUY_STATE.ALL)}>모두보기</MenuItem>
                <MenuItem key={BUY_STATE.AVAILABLE} onClick={(ev)=>selectBuyStateFilter(ev, BUY_STATE.AVAILABLE)}>구매가능</MenuItem>
                <MenuItem key={BUY_STATE.COMPLETE} onClick={(ev)=>selectBuyStateFilter(ev, BUY_STATE.COMPLETE)}>구매완료</MenuItem>
              </Menu>
              <Button
                aria-multiline={false}
                onClick={(event)=>{
                  setWarehouseMenuAnchorEl(event.target)
                }}
                variant={"text"}
                endIcon={<ArrowDropDownOutlined/>}
              >
                {warehouseFilterName}
              </Button>
              <Menu
                id="state-menu"
                anchorEl={warehouseMenuAnchorEl}
                open={warehouseMenuOpen}
                onClose={closeWarehouseMenu}
              >
                <MenuItem key={-1} onClick={(ev)=>selectWarehouse(ev, "-1")}>모든창고</MenuItem>
                {
                  warehouseState.data ?
                    warehouseState.data.results.map((warehouse)=> <MenuItem key={warehouse.id} onClick={(ev)=>selectWarehouse(ev, warehouse.id)}>{warehouse.name}창고</MenuItem>)
                    :
                    <div/>
                }
                {/*<MenuItem onClick={(ev)=>selectWarehouse(ev, "1")}>서초구매</MenuItem>*/}
                {/*<MenuItem onClick={(ev)=>selectWarehouse(ev, "2")}>역삼구매</MenuItem>*/}
              </Menu>
            </Box>

            <FixedSizeList
              ref={listRef}
              onScroll={scroll => {
                // console.log("onScroll", scroll.scrollOffset);
                window.scrollPosition = scroll.scrollOffset;
              }}

              itemCount={list.length}
              height={windowHeight - (224)}
              // height={windowHeight}
              width={windowWidth}
              itemSize={LIST_HEIGHT}
              itemData={list}
              style={{
                padding : 0,
                // position : 'fixed',
                // top : 130,
              }}>
              {listRow}
            </FixedSizeList>
          </Box>

      }
      <Snackbar
        open={snackbar.open}
        autoHideDuration={2000}
        onClose={()=>setSnackbar({open : false, message: ''})}
        message={snackbar.message}
      />
      {/*<Backdrop*/}
      {/*  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}*/}
      {/*  open={requesting}*/}
      {/*  // onClick={handleClose}*/}
      {/*>*/}
      {/*  <CircularProgress color="inherit" />*/}
      {/*</Backdrop>*/}
    </Box>
  )
}